import React from 'react';
import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { userSelect } from '../redux/selectors/index';

// handle the public routes
function PublicRoute({ children }) {
  const users = useSelector(userSelect);

  return (!users?.emailVerification) ? children : <Navigate to="/" replace />;
}
 
export default PublicRoute;
